/**
 * Styled components for EditVendorPageV2 component
 */
import styled from 'styled-components';
import { Steps, Button } from 'antd';
import { Box, Text } from 'atoms';

export const PageContainer = styled(Box)`
	background: #f4f6f8;
	min-height: 100vh;
	padding: 0;
`;

export const HeaderContainer = styled(Box)`
	background: #fff;
	padding: 24px 32px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`;

export const HeaderLeft = styled(Box)`
	flex: 1;
`;

export const DownloadButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 16px;
	height: auto;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #153e60 !important;
		color: #fff !important;
	}
`;

export const BackButton = styled(Button)`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 0;
	height: auto;
	border: none;
	background: transparent;
	color: #1890ff;
	font-size: 16px;
	margin-bottom: 8px;
	cursor: pointer;

	&:hover {
		color: #40a9ff;
	}
`;

export const PageSubtitle = styled(Text)`
	font-size: 14px;
	color: #707070;
	display: block;
`;

export const StepsContainer = styled(Box)`
	background: #fff;
	padding: 32px;
	margin-top: 1px;
`;

export const StyledSteps = styled(Steps)`
	.ant-steps-item-process .ant-steps-item-icon {
		background-color: #18405d;
		border-color: #18405d;
	}

	.ant-steps-item-finish .ant-steps-item-icon {
		background-color: #18405d;
		border-color: #18405d;
	}

	.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
		color: #fff;
	}

	.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
		background-color: #18405d;
	}

	.ant-steps-item-title {
		font-size: 13px;
		color: #8c8c8c;
	}

	.ant-steps-item-process .ant-steps-item-title {
		color: #1c1c1c;
		font-weight: 500;
	}

	.ant-steps-item-finish .ant-steps-item-title {
		color: #1c1c1c;
	}
`;

export const ContentContainer = styled(Box)`
	background: #fff;
	margin: 0 32px;
	margin-top: 1px;
	padding: 32px;
	min-height: calc(100vh - 250px);
`;
